var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageFlip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/page-flip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,4.144 C19.5650142,3.89248502 21.1469406,3.76076925 22.732,3.74990496 C22.8682067,3.74790738 22.9997354,3.79965635 23.098,3.894 C23.1944096,3.98744535 23.2491864,4.11573836 23.25,4.25 L23.25,20.018 C23.2472903,20.2930122 23.0250122,20.5152903 22.75,20.518 C14.457,20.621 12,23.25 12,23.25 L12,6.482 C12,6.482 9.545,3.856 1.268,3.74990496 C1.13110465,3.74737634 0.998758887,3.79916381 0.9,3.894 C0.804325695,3.98777897 0.75028738,4.11602991 0.75,4.25 L0.75,20.018 C0.752709676,20.2930122 0.974987829,20.5152903 1.25,20.518 C9.543,20.621 12,23.25 12,23.25",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22.757 C12.1579981,21.4609563 12.7320462,20.2511042 13.636,19.309 C14.7991974,18.0542295 16.3246294,17.1932902 18,16.846 L18,1.243 C17.9968941,1.07958981 17.9110225,0.928937734 17.772,0.843 C17.6246913,0.750415668 17.4444473,0.726334488 17.278,0.777 C15.8748267,1.18019962 14.6129791,1.96911423 13.636,3.054 C12.7324343,3.99557355 12.1584148,5.20466353 12,6.5",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageFlip);
export default __webpack_public_path__ + "static/media/page-flip.4c267d0d7b2d32572d75c6946e8845f8.svg";
export { ForwardRef as ReactComponent };